import React, { useState, useEffect }  from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { usePrayerRequests } from './hooks/usePrayerRequests';
import { formatDate, formatTime } from './utils/dateUtils';

function PrayerRequestsPage({user, accessToken}) {
    const { getPrayerRequests, updatePrayerRequestStatus } = usePrayerRequests();
    const [prayerRequests, setPrayerRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        (async() => {
            setLoading(true);
            try {
                console.log('getting prayer requests');
                const prayerRequests = await getPrayerRequests(accessToken);
                setPrayerRequests(prayerRequests);
            }
            catch(error) {
                console.log(error);
            }
            finally {
                setLoading(false);
            }
        })()
    }, []);

    const getTimestampText = (timestamp) => {
        return `${formatDate(timestamp)} ${formatTime(timestamp)}`;
    }

    const getStatus = (status) => {
        return status === 'PendingApproval' ? 'Pending Approval' : status;
    }

    const approve = async (id) => {
        const updatedPrayerRequest = await updatePrayerRequestStatus(accessToken, id, 'Active');
        if(updatedPrayerRequest) {
            setPrayerRequests(prayerRequests.map(prayerRequest => {
                if(prayerRequest.id === id) {
                    return updatedPrayerRequest;
                }
                else {
                    return prayerRequest;
                }
            }));
        }
    }

    return (
        <div>
            <h5 style={{textAlign: 'left', marginLeft: '25px', marginBottom: '25px'}}>Prayer Requests:</h5>
            {
                prayerRequests.length ?  
                    <Table striped bordered hover size="sm" style={{width: '97%', margin: '0 auto'}}>
                        <thead>
                            <tr>
                                <th>Created Date</th>
                                <th>Name</th>
                                <th>Text</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            prayerRequests.map(prayerRequest => 
                                <tr key={prayerRequests.id}>
                                    <td style={{textAlign: 'left'}}>{getTimestampText(prayerRequest.createdDate)}</td>
                                    <td>{prayerRequest.name}</td>
                                    <td style={{textAlign: 'left'}}>{prayerRequest.text}</td>
                                    <td>{getStatus(prayerRequest.status)}</td>
                                    <td>
                                        {
                                            prayerRequest.status === 'PendingApproval' && <button onClick={() => approve(prayerRequest.id)}>Approve</button>
                                        }
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </Table>
                : 
                loading ? 'Loading...' : 'There are currently no prayer requests'
            }
        </div>
    );
}

export default PrayerRequestsPage;